<template>
  <ValidationObserver ref="form" tag="div" v-slot="{ errors, failed }">
    <transition name="fade">
      <NotificationMessage :messages="errors" v-if="failed"></NotificationMessage>
    </transition>
    <AGCInput v-model="inputVal.username"
              name="帳戶名稱"
              label="帳戶名稱"
              sub-label="(此名稱將會用作登入商戶中心及重設密碼之用，一經提交便不能修改)"
              class="mb-3"
              placeholder="使用小寫字母a-z、數字0-9或符號 _ 及 -"
              rules="required|username|max:15"
              required
    ></AGCInput>
    <AGCInput v-model="inputVal.contactName"
              name="聯絡人名稱"
              label="聯絡人名稱"
              class="mb-3"
              placeholder="聯絡人名稱"
              rules="required|max:50"
              required
    ></AGCInput>
    <AGCLabel required>
      聯絡電郵
      <template v-slot:subLabel>
        (作內部聯絡及收發系統電郵之用，最多可輸入10個電郵地址)
      </template>
    </AGCLabel>
    <AGCFormTags
      v-model="inputVal.contactEmail"
      name="聯絡電郵"
      input-id="tags-basic"
      :validate-reg-ex="regEx"
      rules="required|maxArray:10"
      placeholder="可輸入多個聯絡電郵，請按Enter 分隔聯絡電郵"
      class="mb-3"
    >
      <template v-slot:invalidTag>
        聯絡電郵無效，請輸入一個有效的聯絡電郵
      </template>
    </AGCFormTags>
    <AGCInput v-model="inputVal.contactPhone"
              name="聯絡電話"
              label="聯絡電話"
              class="mb-3"
              placeholder="聯絡電話"
              rules="required|numeric|min:6|max:12"
              required
    ></AGCInput>
  </ValidationObserver>
</template>

<script>
import formMixin from '@/mixins/form';
import vModelMixin from '@/mixins/v-model';
import AGCInput from '@/components/form/AGCInput.vue';
import NotificationMessage from '@/components/NotificationMessage.vue';
import AGCFormTags from '@/components/form/AGCFormTags.vue';
import AGCLabel from '@/components/form/AGCLabel.vue';

export default {
  mixins: [formMixin, vModelMixin],
  components: {
    AGCInput,
    AGCLabel,
    AGCFormTags,
    NotificationMessage,
  },
  mounted() {
    this.$emit('updated');
  },
  data: () => ({
    regEx: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  }),
};
</script>
